<script>
import FormButtons from '@wielink-application/shared/vue/components/form-buttons.vue'

export default FormButtons;
</script>